(() => {
  let flag = 1;

  document.addEventListener("DOMContentLoaded", function () {
    lazyScripts = document.getElementsByTagName("script");

    window.addEventListener("scroll", init);
    window.addEventListener("mousemove", init);
    window.addEventListener("touchstart", init);
    window.addEventListener("click", init);

    window.addEventListener("touchmove", function () {
      setTimeout(function () {
        init();
      }, 1000);
    });

    setTimeout(function () {
      init();
    }, 8000);
  });

  function init() {
    window.globalScriptObserver.disconnect();

    if (flag) {
      flag = 0;

      window.removeEventListener("scroll", init);
      window.removeEventListener("mousemove", init);
      window.removeEventListener("touchstart", init);

      typeof asyncVendorsLoad !== "undefined" && asyncVendorsLoad();

      // lazyLoadBgImage();
      // lazyLoadIframe();
      load_all_js();
    }
  }

  function lazyLoadBgImage() {
    document.querySelectorAll("[data-bgsrc]").forEach(function (elem) {
      elem.style.backgroundImage = `url(${elem.dataset.bgsrc})`;
    });
  }

  function lazyLoadIframe() {
    document.querySelectorAll("iframe").forEach(function (elem) {
      elem.src = elem.dataset.src || elem.src;
    });
  }

  function load_all_js() {
    setTimeout(function () {
      window.dispatchEvent(new Event("mbc_load"));
    }, 100);

    lazyLoadScripts();
  }

  function lazyLoadScripts() {
    const lazyScripts = document.getElementsByTagName("script");
    let delay = 150;

    let timer = setTimeout(function request() {
      if (typeof $ === "function") {
        clearTimeout(timer);

        Array.from(lazyScripts).forEach((s) => {
          const script = document.createElement("script");

          if (s.type === "lazyload.js") {
            if (s.dataset.src) {
              script.src = s.dataset.src;
              // script.async = true;

              if (s.dataset.adClient !== undefined) {
                script.dataset.adClient = s.dataset.adClient;
              }
              if (s.id.length > 0) {
                script.id = s.id;
              }

              script.defer = true;
              script.setAttribute("data-app-optimization", true);
              document.head.appendChild(script);
            } else if (s.innerHTML) {
              script.type = "text/javascript";
              script.innerHTML = s.innerHTML;
              document.body.appendChild(script);
            }
            s.remove();
          }
        });
      } else {
        delay *= 2;
        timer = setTimeout(request, delay);
      }
    }, delay);
  }

  // function load_all_js() {
  //   setTimeout(function () {
  //     window.dispatchEvent(new Event("mbc_load"));
  //   }, 100);

  //   const lazyScripts = document.getElementsByTagName("script");

  //   Array.from(lazyScripts).forEach((s) => {
  //     if (s.type === "lazyload.js") {
  //       const script = document.createElement("script");

  //       if (s.dataset.src) {
  //         script.src = s.dataset.src;
  //         script.async = s.async;
  //         script.defer = s.defer;
  //         document.head.appendChild(script);
  //       } else if (s.innerHTML) {
  //         script.innerHTML = s.innerHTML;
  //         document.body.appendChild(script);
  //       }

  //       s.remove();
  //     }
  //   });
  // }
})();
